import { render, staticRenderFns } from "./return-carrier.vue?vue&type=template&id=3df555a8&scoped=true&lang=pug"
import script from "./return-carrier.vue?vue&type=script&lang=ts"
export * from "./return-carrier.vue?vue&type=script&lang=ts"
import style0 from "./return-carrier.vue?vue&type=style&index=0&id=3df555a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df555a8",
  null
  
)

export default component.exports